<span *ngIf="value" class="badge rounded-pill d-inline-block text-center py-2 fw-bold {{ badgeClass }}" style="width: 100px;">{{ value }}</span>
